module.exports = __webpack_public_path__ + "static/media/ubs-active.7707a1ed.svg";